import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ActionList from '@components/ActionsMenu/ActionList';
import {
  Content,
  ContextMenuStyled,
} from '@components/MainStage/ContextMenu/ContextMenu.styled';
import {
  clampMenuToPane,
  MenuPosition,
} from '@components/MainStage/ContextMenu/helpers';
import { MenuStateWithItems } from '@components/MainStage/types';
import { SxProps } from '@mui/material';

export function ContextMenu({
  menuItems,
  top,
  left,
  position,
}: Readonly<Omit<MenuStateWithItems, 'id' | 'type'>> & {
  popoverSx?: SxProps;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [resolved, setResolved] = useState<MenuPosition>({ top, left });

  const isFixed = position === 'fixed';

  useLayoutEffect(() => {
    const next = clampMenuToPane({
      desiredTop: top,
      desiredLeft: left,
      menuEl: ref.current,
      isFixed,
    });

    setResolved((prev) =>
      prev.top === next.top && prev.left === next.left ? prev : next,
    );
  }, [isFixed, top, left, menuItems]);

  const content = (
    <ContextMenuStyled
      ref={ref}
      $top={resolved.top}
      $left={resolved.left}
      $position={position}
    >
      <Content>
        <ActionList
          items={menuItems}
          popoverSx={{ '& .MuiPopover-paper': { borderRadius: '4px' } }}
        />
      </Content>
    </ContextMenuStyled>
  );

  return isFixed ? createPortal(content, document.body) : content;
}
